'use es6';

import http from 'hub-http/clients/apiClient';
import formatEmailCampaignUrls from 'reference-resolvers/formatters/formatEmailCampaignUrls';
const BASE_URL = '/cosemail/v1/links';
export const createGetEmailCampaignUrlsById = ({
  httpClient
}) => query => {
  const emailCampaignId = parseInt(query.get('query'), 10);
  return httpClient.get(BASE_URL, {
    query: {
      emailCampaignId,
      truncateQueryParams: true
    }
  }).then(formatEmailCampaignUrls);
};
export const getEmailCampaignUrlsById = createGetEmailCampaignUrlsById({
  httpClient: http
});